import React, { useState } from 'react';
import { InputWrapper } from '../../../styles/EditDeleteStyles';
import { EmailRecipientsSelect } from './Shared/EmailRecipientsSelect';
import InputText from '../../../components/InputText';
import { BannerImageSelect } from './Shared/BannerImageSelect';
import { TextArea } from '../../../components/InputTextArea';
import { Sending } from './Shared/Sending';

type SurveyFeedbackProps = {
  onChange: (data: any) => void;
  error?: any;
  loading: boolean;
};

export function SurveyFeedback({ onChange, error, loading }: SurveyFeedbackProps): JSX.Element {
  const [recipient, setRecipient] = useState<any>('all');
  const [subject, setSubject] = useState<string>('');
  const subjectFormKey = 'survey_feedback_subject';
  const [bannerImage, setBannerImage] = useState<File>({} as File);
  const [bannerImageName, setBannerImageName] = useState<string>('');
  const [openMessage, setOpenMessage] = useState<string>('');
  const openingMessageFormKey = 'survey_feedback_opening_message';
  const [body, setBody] = useState<string>('');
  const bodyFormKey = 'survey_feedback_body';
  const [surveyButtonText, setsurveyButtonText] = useState<string>('');
  const surveyButtonTextFormKey = 'survey_feedback_button_text';
  const [surveyButtonUrl, setsurveyButtonUrl] = useState<string>('');
  const surveyButtonUrlFormKey = 'survey_feedback_button_url';
  const [administeredBy, setAdministeredBy] = useState<string>('');
  const administeredByFormKey = 'survey_feedback_administered_by';

  React.useEffect(() => {
    setBannerImageName(bannerImage?.name || '');
  }, [bannerImage]);

  React.useEffect(() => {
    onChange({
      recipient,
      subject,
      bannerImage,
      bannerImageName,
      openMessage,
      body,
      surveyButtonText,
      surveyButtonUrl,
      administeredBy,
    });
  }, [
    recipient,
    subject,
    bannerImage,
    bannerImageName,
    openMessage,
    body,
    surveyButtonText,
    surveyButtonUrl,
    administeredBy,
    onChange,
  ]);

  if (loading) return <Sending />;

  return (
    <>
      <InputWrapper>
        <EmailRecipientsSelect
          initialValue={recipient}
          handleChange={(update) => {
            const { recipients } = update;
            setRecipient(recipients);
          }}
        />
      </InputWrapper>
      <InputWrapper>
        <InputText
          id={subjectFormKey}
          keyName={subjectFormKey}
          label="Subject"
          error={error?.subject}
          placeholder="Email subject for Survey / Feedback"
          inputValue={subject}
          handleHandle={setSubject}
          padding={false}
          theme="form"
          style={{ width: '610px' }}
        />
      </InputWrapper>
      <BannerImageSelect
        handleChange={(value: File) => setBannerImage(value)}
        fileName={bannerImage?.name}
        error={error?.bannerImageName}
      />
      <InputWrapper>
        <TextArea
          id={openingMessageFormKey}
          keyName={openingMessageFormKey}
          label={
            <>
              <div>Opening Message</div>
              <div
                style={{ fontSize: '12px', color: '#888', marginTop: '8px', fontWeight: 'normal' }}
              >
                Optional
              </div>
            </>
          }
          placeholder="Add your opening message here"
          textValue={openMessage}
          handleHandle={setOpenMessage}
          style={{ height: '75px' }}
        />
      </InputWrapper>
      <InputWrapper>
        <TextArea
          id={bodyFormKey}
          keyName={bodyFormKey}
          label="Email main body text"
          error={error?.body}
          placeholder="Add your email main body text here"
          textValue={body}
          handleHandle={setBody}
        />
      </InputWrapper>
      <InputWrapper>
        <InputText
          id={surveyButtonTextFormKey}
          keyName={surveyButtonTextFormKey}
          label="Survey Button Text"
          error={error?.surveyButtonText}
          placeholder="Add text for the survey button"
          inputValue={surveyButtonText}
          handleHandle={setsurveyButtonText}
          padding={false}
          theme="form"
          style={{ width: '610px' }}
        />
      </InputWrapper>
      <InputWrapper>
        <InputText
          id={surveyButtonUrlFormKey}
          keyName={surveyButtonUrlFormKey}
          label="Survey Button URL"
          error={error?.surveyButtonUrl}
          placeholder="Add URL for the survey button (include https://)"
          inputValue={surveyButtonUrl}
          handleHandle={setsurveyButtonUrl}
          padding={false}
          theme="form"
          style={{ width: '610px' }}
        />
      </InputWrapper>
      <InputWrapper>
        <InputText
          id={administeredByFormKey}
          keyName={administeredByFormKey}
          label="Administered by"
          error={error?.administeredBy}
          placeholder="Email subject for Survey / Feedback"
          inputValue={administeredBy}
          handleHandle={setAdministeredBy}
          padding={false}
          theme="form"
          style={{ width: '610px' }}
        />
      </InputWrapper>
    </>
  );
}
